import { localStorage } from 'dibs-browser-storage';
import get from 'lodash.get';

import { MAX_DAYS, MAX_RECENTLY_VIEWED_ITEMS, RECENT_HISTORY_LIST } from './recentHistoryConstants';

const daysBetween = function(timestamp1, timestamp2) {
    const timeDiff = Math.abs(timestamp1 - timestamp2);
    const oneDayInMs = 86400000; // 24h/d * 60m/h * 60s/m * 1000ms/s
    return Math.round(timeDiff / oneDayInMs);
};

export const isValidRecentHistoryItem = function(item, currentItem) {
    const currentTime = new Date().getTime();
    const itemId = item.itemId || item.item_id;
    const isCurrentItem = itemId === get(currentItem, 'itemId') || '';
    return daysBetween(item.timestamp, currentTime) < MAX_DAYS && !isCurrentItem;
};

export const getLocalRecentHistoryList = function(
    currentItem = null,
    maxRecentHistoryItems = MAX_RECENTLY_VIEWED_ITEMS
) {
    const localRecentHistoryList = localStorage.getItem(RECENT_HISTORY_LIST) || [];
    const recentHistoryList = [];
    const index = maxRecentHistoryItems * -1;

    localRecentHistoryList.forEach(localRecentHistoryItem => {
        if (isValidRecentHistoryItem(localRecentHistoryItem, currentItem)) {
            recentHistoryList.push(localRecentHistoryItem);
        }
    });

    if (recentHistoryList.length > maxRecentHistoryItems) {
        return recentHistoryList.slice(index);
    }
    return recentHistoryList;
};
